import React from 'react';

import RowBetween from '../../../../../../../components/Layout/RowBetween';
import Button from '../../../../../../../components/Button';
import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import { getWindowWidth } from '../../../../../../../lib/utils/utils';
import { Chose } from '../../../../../../../assets/svg-image/tab';

const Tabs: React.FC<Props> = ({
  isEnglish,
  tabIndex,
  setTabIndex,
}) => {
  const width = getWindowWidth() - 30;
  const height = 53;
  // 原图片是435 * 141尺寸
  const ratio = 435 / 141;
  const tabWidth = ratio * height;

  return (
    <>
      <div
        style={{
          width,
          height,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 30,
        }}
      >
        <div
          style={{
            width,
            height,
            borderRadius: 10,
            backgroundColor: '#11202B',
            boxShadow: 'rgb(0,181,149,0.05)',
          }}
        />
      </div>

      <RowBetween style={{ alignItems: 'center', width, marginTop: -height, marginLeft: 'auto', marginRight: 'auto' }}>
        <Button
          onClick={() => setTabIndex(0)}
          style={{ height, width: width * 0.5, flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <img src={Chose} style={{ height, marginTop: 5, marginLeft: 4, opacity: tabIndex === 0 ? 1 : 0 }} />
          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} color={'#FFFFFF'} lineHeight={height} marginTop={-height - 4} width={tabWidth} textAlign={'center'} marginLeft={4}>
                By name
              </SquadSemiBoldText>
            ) : (
              <PingFangMediumText fontSize={16} color={'#FFFFFF'} lineHeight={height} marginTop={-height - 4} width={tabWidth} textAlign={'center'} marginLeft={4}>
                搜索姓名
              </PingFangMediumText>
            )
          }
        </Button>
        <Button
          onClick={() => setTabIndex(1)}
          style={{ height, width: width * 0.5, flexDirection: 'column', alignItems: 'flex-end' }}
        >
          <img src={Chose} style={{ height, marginTop: 5, marginRight: 4, opacity: tabIndex === 1 ? 1 : 0 }} />
          {
            isEnglish ? (
              <SquadSemiBoldText fontSize={16} color={'#FFFFFF'} lineHeight={height} marginTop={-height - 4} width={tabWidth} textAlign={'center'} marginRight={4}>
                By phone
              </SquadSemiBoldText>
            ) : (
              <PingFangMediumText fontSize={16} color={'#FFFFFF'} lineHeight={height} marginTop={-height - 4} width={tabWidth} textAlign={'center'} marginRight={4}>
                搜索电话
              </PingFangMediumText>
            )
          }
        </Button>
      </RowBetween>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  tabIndex: number;
  setTabIndex: (index: number) => void;
}

export default Tabs;
